// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__LYkLr","title-wrapper":"Hero_title-wrapper__EO9kZ","title":"Hero_title__0OLts","img-wrapper":"Hero_img-wrapper__dUGdV"};